<template>
  <div class="wish-list-contents__tickets">
    <Ticket
      v-for="ticket in tickets"
      :key="ticket.id"
      class="wish-list-contents__ticket"
      :image-url="ticket.imageUrl"
      :item-name="ticket.itemName"
      :item-sku-name="ticket.itemSkuName"
      :brand-name="ticket.brandName"
      :showable-giftee-asterisk="false"
      :is-ticket-sold-out="ticket.isSoldOut"
      :expiration-date="''"
      :is-ticket-expired="false"
      @click-ticket="clickTicket(ticket.itemId, ticket.itemSkuId)"
    />
    <TextModalWithSecondary
      v-if="isModalActive && isSameUserAsGiftCardRecipient"
      :title-text="'作成中のギフトカードがあります'"
      :caption-text="
        '作成できるカードは１つまでです。\n内容を破棄して新規作成しますか?'
      "
      :primary-button-text="'新規作成する'"
      :secondary-button-text="'カードを確認する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="createGiftCard"
      @clicked-secondary="moveToGiftCardEditPage"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import Ticket from '../../../atoms/tickets/Ticket'
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary'

import axios from 'axios'

export default {
  components: {
    Ticket,
    TextModalWithSecondary
  },
  props: {
    tickets: {
      type: Array,
      require: true,
      default: () => {}
    },
    screenName: {
      type: String,
      require: true,
      default: ''
    },
    isSameUserAsGiftCardRecipient: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      isModalActive: false,
      selectTicketItemId: null,
      selectTicketitemSkuId: null
    }
  },
  methods: {
    clickTicket(itemId, itemSkuId) {
      dataLayer.push({
        event: 'add_to_cart',
        item_sku_id: itemSkuId,
        ecommerce: {
          items: [
            {
              item_id: itemSkuId,
              quantity: 1,
              item_list_name: 'wishlist'
            }
          ]
        }
      })
      this.selectTicketItemId = itemId
      this.selectTicketitemSkuId = itemSkuId

      if (this.isSameUserAsGiftCardRecipient) {
        this.isModalActive = true
        return
      }
      this.createGiftCard()
    },
    async createGiftCard() {
      try {
        await axios.post('/api/v1/pickup/gift_card_session_item_sku_contents', {
          item_sku_form: {
            item_id: this.selectTicketItemId,
            item_sku_id: this.selectTicketitemSkuId,
            screen_name: this.screenName
          }
        })
        location.href = '/gift_card/edit'
      } catch (error) {
        this.$emit('error', error)
      }
    },
    closeModal() {
      this.isModalActive = false
      this.selectTicketItemId = null
      this.selectTicketitemSkuId = null
    },
    moveToGiftCardEditPage() {
      location.href = '/gift_card/edit'
      this.isModalActive = false
    }
  }
}
</script>
